import { useQuery } from '@tanstack/react-query'
import { search } from '~/lib/api'

type MenuItem = {
  id: number
  title: string
  slug: string
  url: string
  parentSlug?: string
  sort: number
  showMenu: boolean
}

export function useMenuItems(languageCode: string = 'vi') {
  return useQuery<MenuItem[]>({
    queryKey: ['menu-items', languageCode],
    queryFn: async () => {
      const res = await search('page', {
        filter: {
          translations: {
            languages_code: { _eq: languageCode },
          },
        },
        fields: [
          'id',
          'show_in_header',
          'sort_menu',
          'translations.title',
          'translations.slug',
          'translations.languages_code',
          'parent_id.translations.title',
          'parent_id.translations.slug',
          'parent_id.translations.languages_code',
        ],
        sort: ['sort_menu'],
      })

      const mapped = res.map((item: any): MenuItem | null => {
        const trans = item.translations.find((t: any) => t.languages_code === languageCode)
        const parentTrans = item.parent_id?.translations?.find(
          (t: any) => t.languages_code === languageCode
        )

        if (!trans?.slug) return null

        return {
          id: item.id,
          title: trans.title,
          slug: trans.slug,
          url: parentTrans?.slug ? `/${parentTrans.slug}/${trans.slug}` : `/${trans.slug}`,
          parentSlug: parentTrans?.slug || undefined,
          sort: item.sort_menu || 0,
          showMenu: item.show_in_header || false,
        }
      })

      // ⚠️ Quan trọng: filter lại để bỏ null trước khi trả về
      return mapped.filter((item): item is MenuItem => item !== null)
    },
    staleTime: 5 * 60 * 1000,
  })
}
